"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Amazon(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M12.14 2c1.342 0 3.104.35 4.164 1.357 1.343 1.242 1.222 2.91 1.222 4.715v4.246c0 1.28.517 1.853 1.022 2.544.176.249.224.533 0 .715-.563.469-1.568 1.34-2.119 1.828v-.026a.572.572 0 0 1-.648.074c-.917-.755-1.096-1.11-1.597-1.827-1.514 1.529-2.574 1.999-4.537 1.999-2.324 0-4.139-1.43-4.139-4.27 0-2.22 1.212-3.728 2.942-4.468 1.497-.651 3.585-.76 5.186-.938v-.37c0-.651.064-1.413-.325-1.975-.335-.503-.977-.716-1.545-.716-1.052 0-1.989.547-2.219 1.654-.048.247-.248.48-.499.494L6.38 6.764c-.226-.05-.465-.226-.399-.568C6.595 2.983 9.513 2 12.141 2zm.997 8.139l-.249.007c-1.742.113-3.342.704-3.342 2.739 0 1.184.612 1.976 1.671 1.976.775 0 1.481-.466 1.92-1.235.459-.802.499-1.552.5-2.41v-1.07c-.25 0-.5-.016-.749 0zM2.141 16.885c-.146.02-.204.208-.05.347 2.608 2.33 6.047 3.726 9.874 3.726 2.73 0 5.917-.845 8.104-2.444.361-.265.046-.674-.324-.518a19.89 19.89 0 0 1-7.555 1.53c-3.594 0-7.06-.971-9.874-2.592a.32.32 0 0 0-.175-.05m18.375-.37c-.698.012-1.517.158-2.143.594-.192.133-.164.32.05.296.705-.084 2.262-.282 2.543.073.28.355-.31 1.815-.574 2.469-.079.196.095.272.275.123 1.173-.973 1.487-2.99 1.247-3.284-.119-.144-.697-.28-1.398-.27", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Amazon;
